(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
	
	window.onload = function () {
		if($('.hs-form').hasClass('hs-custom-style')){
			$('.hs-form').removeClass('hs-custom-style')
		}
	}

	//Detect browser's user agent and add to HTML attribute.
	var doc = document.documentElement;
	doc.setAttribute('data-useragent', navigator.userAgent);

	//Since HubSpot forms are rendered after the DOM builds, you must trigger the manipulation after the window loads
	window.onload = function () {
	  	$('.form--floating-labels').each(function () {

    		var form = $(this);

		    if (!form.is('form')) {
        		form = $(this).find('form');
    	}

    var fields = form[0].querySelectorAll('.hs-input');

    [].forEach.call(fields, function(field) {
        if (field.value) {
            field.closest('.hs-form-field').classList.remove('not-focused');
            field.closest('.hs-form-field').classList.add('has-focus');
        }

        field.addEventListener('focus', function () {
            this.closest('.hs-form-field').classList.remove('not-focused');
            this.closest('.hs-form-field').classList.add('has-focus');
        });

        field.addEventListener('blur', function () {
            if(!this.value) {
                this.closest('.hs-form-field').classList.remove('has-focus');
                this.closest('.hs-form-field').classList.add('not-focused');
            } else {
                this.closest('.hs-form-field').classList.remove('has-value');
            }
        });

        field.addEventListener('change', function () {
            if(!this.value) {
                this.closest('.hs-form-field').classList.remove('has-value');
            }
        });
    });
});
	};   

})();